import React from 'react';
import { useTranslation } from 'react-i18next';
import { Container, Header, Segment, List, Icon } from 'semantic-ui-react';
import classes from "./FootersPages.module.css";

export default function DocumentationTexteLinks() {
  const { t } = useTranslation();

  const steps = [
    { title: t('documentation.step1'), path: "/guide/creer-compte", description: t('documentation.step1_description') },
    { title: t('documentation.step2'), path: "/guide/choisir-modele", description: t('documentation.step2_description') },
    { title: t('documentation.step3a'), path: "/guide/selectionner-histoire", description: t('documentation.step3a_description') },
    { title: t('documentation.step3b'), path: "/guide/creer-histoire", description: t('documentation.step3b_description') },
    { title: t('documentation.step4'), path: "/guide/creation-parametres-avancés", description: t('documentation.step4_description') },
  ];

  return (
    <Container className={classes.documentationLinks} style={{ padding: '3em 0em' }}>
      <Segment basic textAlign="center">
        <Header as="h1" style={{ fontSize: '2.5em', color: '#2a2a2a' }}>{t('documentation.header')}</Header>
        <p style={{ fontSize: '1.33em', color: '#5a5a5a', marginBottom: '2em' }}>
          {t('documentation.description')}
        </p>
      </Segment>
      <Segment basic>
        <List divided relaxed>
          {steps.map((step, index) => (
            <List.Item href={step.path} key={index} className={classes.stepItem}>
              <Icon name="arrow right" size="large" color="blue" />
              <List.Content>
                <List.Header as="a" style={{ fontSize: '1.5em', color: '#0056b3' }}>
                  {step.title}
                </List.Header>
                <List.Description style={{ color: '#5a5a5a' }}>{step.description}</List.Description>
              </List.Content>
            </List.Item>
          ))}
        </List>
      </Segment>
    </Container>
  );
}